<template>
  <div class="case_container">
    <div class="cases_white"></div>
    <div class="cases">
      <div
        v-for="(item, index) in cases"
        :key="index"
        @click="toDetailPage(item.id)"
        class="case_div"
      >
        <div class="image-wrapper">
          <img :src="item.picUrl" alt="案例1" />
          <div class="case_div_sec">
            <span v-html="item.details">{{ item.details }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import "../../../static/css/oaim.css"

export default {
  name: "Cases",
  data() {
    return {
      cases: [],
    }
  },
  mounted() {
    this.getCases()
  },
  methods: {
    getCases() {
      axios.get("/back/cases/allList").then(res => {
        const data = res.data.data
        this.cases = data.map(item => ({
          picUrl: item.picUrl,
          details: item.details,
          id: item.id
        }))
      }).catch(err => {
        console.log(err)
      })
    },
    toDetailPage(id) {
      this.$router.push({
        path: "/index/detail",
        name: "Detail",
        query: { key: id }
      })
    }
  }
}
</script>

<style>
.case_container {
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;
  transform: translateY(18mm);
  margin-bottom: 25mm !important;
}

.cases_white {
  width: 100%;
  height: 70px;
}

/* 图片整体居中，最大宽度限制 */
.cases {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 auto;
  max-width: 1250px;
  width: 100%;
}

.case_div {
  width: calc(33.33% - 2.5%);
  margin: 1.25%;
  box-sizing: border-box;
  cursor: pointer;
}

.image-wrapper {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.image-wrapper img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}

/* 蒙层初始状态：透明 + 位移到底部 */
.case_div_sec {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(254, 252, 252, 0.62);
  color: black;
  font-family: "oaimFont";
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  opacity: 0;
  transform: translateY(100%);
  transition: opacity 0.3s ease, transform 0.3s ease;
  pointer-events: none;
}

/* 悬停时蒙层从下往上进入 */
.image-wrapper:hover .case_div_sec {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}

/* 响应式调整 */
@media (max-width: 1100px) {
  .case_div {
    width: calc(50% - 2.5%);
    margin: 1.25%;
  }
}

@media (max-width: 600px) {
  .case_div {
    width: calc(100% - 2.5%);
    margin: 1.25% 0;
  }

  .case_div_sec {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/cases/Cases.vue